import { themeCssVar, themeStatusVar } from './theme.status.defaults';

/** Paleta para eventos de calendario (series distinguibles por tenant). */
export const CALENDAR_SERIES_CSS_VARS = [
    '--calendar-series-1',
    '--calendar-series-2',
    '--calendar-series-3',
    '--calendar-series-4',
    '--calendar-series-5',
    '--calendar-series-6',
    '--calendar-series-7',
    '--calendar-series-8',
    '--calendar-series-9',
    '--calendar-series-10',
    '--calendar-series-11',
    '--calendar-series-12',
] as const;

export type CalendarColorPair = { primary: string; secondary: string };

export const buildCalendarColorPalette = (): CalendarColorPair[] =>
    CALENDAR_SERIES_CSS_VARS.map((cssVar) => ({
        primary: themeCssVar(cssVar),
        secondary: themeCssVar(cssVar),
    }));

/** Paleta completa usada en schedule-case (estados + series). */
export const SCHEDULE_CALENDAR_COLORS: CalendarColorPair[] = [
    { primary: themeStatusVar('statusScheduled'), secondary: themeStatusVar('statusScheduled') },
    { primary: themeStatusVar('statusInProgress'), secondary: themeStatusVar('statusInProgress') },
    ...buildCalendarColorPalette().slice(0, 3),
    { primary: themeStatusVar('statusNotDone'), secondary: themeStatusVar('statusNotDone') },
    { primary: themeStatusVar('statusInformed'), secondary: themeStatusVar('statusInformed') },
    ...buildCalendarColorPalette().slice(5),
];

export const MODULE_CALENDAR_COLORS: CalendarColorPair[] = [
    { primary: themeCssVar('--calendar-series-1'), secondary: themeCssVar('--calendar-series-1') },
    { primary: themeStatusVar('statusScheduled'), secondary: themeStatusVar('statusScheduled') },
    { primary: themeStatusVar('statusInProgress'), secondary: themeStatusVar('statusInProgress') },
    { primary: themeCssVar('--calendar-series-2'), secondary: themeCssVar('--calendar-series-2') },
    { primary: themeStatusVar('statusInformed'), secondary: themeStatusVar('statusInformed') },
    { primary: themeCssVar('--calendar-series-6'), secondary: themeCssVar('--calendar-series-6') },
];

export const SCHEDULE_FLOW_COLORS = {
    moduleHeaderBg: themeCssVar('--schedule-module-header-bg'),
    moduleHeaderColor: themeCssVar('--schedule-module-header-color'),
    practiceHeaderBg: themeCssVar('--schedule-practice-header-bg'),
    practiceHeaderColor: themeCssVar('--schedule-practice-header-color'),
    successHeaderBg: themeCssVar('--schedule-success-header-bg'),
    successHeaderColor: themeCssVar('--schedule-success-header-color'),
} as const;
